var exports = {
  "u": "x234b8571--67ba11--toggle-btn",
  "q": "x234b8571--67ba11--toggle-btn--close",
};

module.exports = exports;
